let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jhLKO")).then(() => parcelRequire('8khb6'));